import { format, isEqual, isToday } from 'date-fns';
import { DateRange } from 'react-day-picker';

export const formatPickerDate = (date: DateRange | Date | undefined, t: (key: string) => string): string => {
  const dateFormat = 'LLL dd';

  const formatDate = (date: Date) => {
    if (isToday(date)) {
      return t('pm:today'); // Use the translation for "today"
    }

    return format(date, dateFormat);
  };

  if (!date) {
    return t('common:pickADate'); // Use the translation for "pick a date"
  }

  // Check if `date` is a single date or a range
  if (date instanceof Date) {
    return formatDate(date); // Format single date
  }

  // Format date range
  if (!date.from) {
    return t('common:pickADate'); // Use the translation for "pick a date"
  }

  if (!date.to || isEqual(date.from, date.to)) {
    return formatDate(date.from);
  }

  return `${formatDate(date.from)} - ${formatDate(date.to)}`;
};

export const getToday = (): Date => {
  const today = new Date();

  today.setHours(0, 0, 0, 0);

  return today;
};

export const getPreviousDay = (): Date => {
  const previousDay = new Date();

  previousDay.setDate(previousDay.getDate() - 1);

  previousDay.setHours(0, 0, 0, 0);

  return previousDay;
};

export const formatDateTime2Digit = (date: string | undefined) => {
  if (!date) {
    return '';
  }

  const dateOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  return new Intl.DateTimeFormat('de', dateOptions).format(new Date(date));
};

export const formatTime = (date: string | undefined) => {
  if (!date) {
    return '';
  }

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  };

  return new Intl.DateTimeFormat('de', timeOptions).format(new Date(date));
};

export const isSameDay = (startDate: string | undefined, endDate: string | undefined) => {
  if (!startDate || !endDate) {
    return false;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  return start.toDateString() === end.toDateString();
};
